import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import hikaru from "../../Assets/Projects/HikaruOsariChibi.png";
import sora from "../../Assets/Projects/Sora_Harukawa_Anime_Chibi.png";
import ai from "../../Assets/Projects/AiChibi.png";
import nero from "../../Assets/Projects/Nero_Chibi.png";

function AssetDrives() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Asset Drives <span className="wave" role="img" aria-labelledby="wave">📂</span>
        </h1>
        <p class="green" style={{ color: "white", fontWeight: "bold" }}>
        <strong>DISCLAIMER:</strong> The images posted in the Google Drives are copyrighted to: <br/><br/>

          - Happy Elements K.K<br/>
          - Happy Elements<br/>
          - Broccoli / KLAB<br/>
          - MAGES<br/>
          - coly Inc.<br/><br/>

It will be used in a way that qualifies as fair use under US copyright law. You may use them for your personal usage in creative works, but you are not allowed to profit from them.</p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sora}
              isBlog={true}
              title="Ensemble Stars Assets Drive"
              description="Currently UNAVAILABLE."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ai}
              isBlog={true}
              title="Utapri Shining Live Renders Drive"
              description=""
              link="https://drive.google.com/folderview?id=1IXmwH7wBU98HdpJyNuHCAU2xwpBb5YMR"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hikaru}
              isBlog={true}
              title="B-PROJECT Renders and CG Drive"
              description=""
              link="https://drive.google.com/folderview?id=1Y8aNKnX65q4vkyKCOqFEBfmZ1FEJ43Hb"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nero}
              isBlog={true}
              title="Mahoyaku Assets Drive"
              description=""
              link="https://drive.google.com/drive/folders/1MO6r5frOSCQs1tv2_ygAyVTBmI6ClGz1"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default AssetDrives;
